import { useLang } from '@/hooks/useLang';

const BASE = 'https://www.yamamoto-ss.co.jp/sp_recycle';

const newsItems = [
  {
    date: '2025.11.07',
    titleEn: 'Year-End / New Year Holiday Notice',
    titleJa: '年末年始休業のお知らせ',
    href: 'https://www.yamamoto-ss.co.jp/news/news_238.html',
    genreEn: 'Notice',
    genreJa: 'その他',
  },
  {
    date: '2025.10.21',
    titleEn: 'New case study added: Purasiru plastic ID device',
    titleJa: 'ぷらしる 導入事例を1件追加しました',
    href: `${BASE}/news/news_97.html`,
    genreEn: 'Update',
    genreJa: '更新',
  },
  {
    date: '2025.07.24',
    titleEn: 'Summer Holiday Notice',
    titleJa: '夏季休業のお知らせ',
    href: 'https://www.yamamoto-ss.co.jp/news/news_227.html',
    genreEn: 'Notice',
    genreJa: 'その他',
  },
  {
    date: '2025.06.16',
    titleEn: 'New case study added: EPS Compactor installation',
    titleJa: '発泡スチロール減容機 導入事例を1件追加しました',
    href: `${BASE}/news/news_95.html`,
    genreEn: 'Update',
    genreJa: '更新',
  },
];

export default function NewsSection() {
  const { lang, t } = useLang();
  return (
    <section className="py-14 max-w-screen-lg mx-auto px-6">
      <div className="flex items-center justify-between mb-8">
        <h2 className="text-2xl font-bold text-[#222] tracking-wide">NEWS</h2>
        <a href={`${BASE}/news/`} className="text-xs text-[#c0392b] hover:underline whitespace-nowrap">
          {t('View All', 'すべて見る')} &rsaquo;
        </a>
      </div>
      <ul className="divide-y divide-gray-200">
        {newsItems.map((item) => {
          const genre = lang === 'en' ? item.genreEn : item.genreJa;
          const title = lang === 'en' ? item.titleEn : item.titleJa;
          const isUpdate = item.genreEn === 'Update';
          return (
            <li key={item.href} className="py-4 flex flex-col sm:flex-row sm:items-center gap-2 sm:gap-6">
              <span className="text-xs text-[#888] whitespace-nowrap">{item.date}</span>
              <span className={`text-[10px] px-2 py-0.5 rounded-sm whitespace-nowrap font-medium ${isUpdate ? 'bg-[#c0392b]/10 text-[#c0392b]' : 'bg-[#eee] text-[#666]'}`}>
                {genre}
              </span>
              <a href={item.href} className="text-sm text-[#333] hover:text-[#c0392b] transition-colors leading-snug">
                {title}
              </a>
            </li>
          );
        })}
      </ul>
    </section>
  );
}
